<script setup lang="ts">
import { computed, watch } from "vue";
import { useRouter } from "vue-router";

import { useMessageStore } from "@/stores/message-store";
import { ref } from "vue";

const $router = useRouter();
const timeoutId = ref<ReturnType<typeof setTimeout> | null>(null);

const messageDetail = computed(() => useMessageStore().messageDetail);

watch(messageDetail, (_, _b, onCleanup) => {
  if (messageDetail.value?.message == null || !messageDetail.value.autoHide) return;

  timeoutId.value = setTimeout(() => useMessageStore().clearMessage(), 5000);

  onCleanup(() => {
    if (timeoutId.value != null) clearTimeout(timeoutId.value);
  });
});

function clear(): void {
  useMessageStore().clearMessage();
}

// TODO Bootstrap to tailwind: add transitions. Update colors for warning and success
</script>
<template>
  <div
    v-if="messageDetail != null"
    v-show="useMessageStore().show"
    class="tw-b-r w-350 z-lg tw-fixed tw-right-0 tw-top-0 tw-m-4 tw-border-r tw-bg-white tw-leading-6"
    :class="{
      'tw-border-blue-100 tw-bg-blue-100': messageDetail.type === 'info',
      'tw-border-red-200 tw-bg-red-200': messageDetail.type === 'error',
      'tw-border-gray-200 tw-bg-gray-200': messageDetail.type === 'success' || messageDetail.type === 'warning',
    }"
  >
    <div
      class="tw-flex tw-flex-grow tw-items-baseline tw-justify-between tw-px-2 tw-py-1"
      :class="{
        'tw-border-blue-200 tw-bg-blue-200': messageDetail.type === 'info',
        'tw-border-red-300 tw-bg-red-300': messageDetail.type === 'error',
        'tw-border-gray-300 tw-bg-gray-300': messageDetail.type === 'success' || messageDetail.type === 'warning',
      }"
    >
      <strong class="tw-mr-auto">{{ messageDetail.title }}</strong>
      <button title="Clear Message" @click="clear">
        <i class="fa fa-times" />
      </button>
    </div>
    <p class="tw-p-2">{{ messageDetail.message }}</p>
    <button
      v-if="messageDetail.showReload"
      class="tw-mt-2 tw-bg-white tw-p-2 tw-text-gray-800"
      @click.prevent="$router.go(0)"
    >
      Reload
    </button>
  </div>
</template>
<style>
.w-350 {
  width: 350px;
}
.z-lg {
  z-index: 999999;
}
</style>
